import { mapLinkableEntityType } from '..';
import { ShowWithTourType as ShowWithTourTypeApiType } from 'src/api/generated/touring/types';
import { ShowWithTourType } from '../../types';

export const mapShowWithTourType = (
  apiShowWithTourType: ShowWithTourTypeApiType
): ShowWithTourType => {
  return {
    showId: apiShowWithTourType.showId,
    showDate: apiShowWithTourType.showDate,
    tour: mapLinkableEntityType(apiShowWithTourType.tour),
    artist: mapLinkableEntityType(apiShowWithTourType.artist),
    coHeadliner1: apiShowWithTourType.coHeadliner1
      ? mapLinkableEntityType(apiShowWithTourType.coHeadliner1)
      : null,
    coHeadliner2: apiShowWithTourType.coHeadliner2
      ? mapLinkableEntityType(apiShowWithTourType.coHeadliner2)
      : null,
    venue: mapLinkableEntityType(apiShowWithTourType.venue),
    city: apiShowWithTourType.city,
  };
};
